module.exports = __webpack_public_path__ + "img/media.5d536327.png";